import { ProjectPaymentDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProjectPayment = createAction(
  '[ProjectPayment] Load ProjectPayment'
);

export const loadProjectPaymentSuccess = createAction(
  '[ProjectPayment] Load ProjectPayment Success',
  props<{ projectPayment: ProjectPaymentDto[] }>()
);

export const loadProjectPaymentFailure = createAction(
  '[ProjectPayment] Load ProjectPayment Failure',
  props<{ error: any }>()
);

/**
 * Add Project to Collection Actions
 */
export const addProjectPayment = createAction(
  '[ProjectPayment] Add ProjectPayment',
  props<{ newProjectPayment: ProjectPaymentDto[] }>()
);

export const addProjectPaymentSuccess = createAction(
  '[ProjectPayment] Add ProjectPayment Success',
  props<{ newProjectPayment: ProjectPaymentDto[] }>()
);

export const addProjectPaymentFailure = createAction(
  '[ProjectPayment] Add ProjectPayment Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchProjectPaymentRecord = createAction(
  '[ProjectPayment] Search  ProjectPayment Record',
  props<{ query: string }>()
);

/**
 * Update ProjectPayment Collection Actions
 */
export const updateProjectPayment = createAction(
  '[ProjectPayment] Update ProjectPayment',
  props<{ updateProjectPayment: ProjectPaymentDto[] }>()
);

export const updateProjectPaymentSuccess = createAction(
  '[ProjectPayment] Update ProjectPayment Success',
  props<{ updateProjectPayment: ProjectPaymentDto[] }>()
);

export const updateProjectPaymentFailure = createAction(
  '[ProjectPayment] Update ProjectPayment Failure',
  props<{ error: any }>()
);

/**
 * Remove ProjectPayment Collection Actions
 */
export const removeProjectPayment = createAction(
  '[ProjectPayment] Remove ProjectPayment',
  props<{ ids: string[] }>()
);

export const removeProjectPaymentSuccess = createAction(
  '[ProjectPayment] Remove ProjectPayment Success',
  props<{ ids: string[] }>()
);

export const removeProjectPaymentFailure = createAction(
  '[ProjectPayment] Remove ProjectPayment Failure',
  props<{ error: any }>()
);
